export default "__VITE_ASSET__DtpMXbFS__"